module.exports = __webpack_public_path__ + "img/1.dc0a1b6e.png";